import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const systemList = {
    colorNumber: '#00B9FF',
    list: ['Research list', 'Outreach list'],
};

const System = () => {
    return (
        <div className="linkbuilder-system__content-wrap">
            <FullWrapper smallPaddings={true} isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="linkbuilder-system__content">
                        <CommonTitle>Система</CommonTitle>
                        <CommonUsualText>В интерфейсе пользователя два списка:</CommonUsualText>
                        <CommonOlList
                            className="linkbuilder-system__list"
                            CommonOlList={systemList}
                        />

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-system__grid mobile-order"
                        >
                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-hidden">
                                        Research list
                                    </div>
                                    <CommonUsualText className="linkbuilder-system-item__subtitle">
                                        В Research list тысячи доменов сайтов, на которых можно
                                        купить ссылки, и информация о них, собранная ИИ, а именно
                                        следующие параметры:
                                    </CommonUsualText>
                                    <div className="linkbuilder-system-item__small-text">
                                        <p>
                                            <b>Citation Flow (СF)</b> — это одна из метрик сервиса
                                            Majestic, подобие нормированного PageRank. Поток
                                            Цитирования (Citation Flow) помогает определить долю
                                            «силу» ссылок, которой обладает сайт или ссылка.
                                            Citation Flow (СF) используется в сочетании с Trust Flow
                                            (TF);
                                        </p>
                                        <p>
                                            <b>Trust Flow (TF)</b> — это одна из метрик сервиса
                                            Majestic, подобие классического Trust Rank. Поток
                                            Доверия (Trust Flow) определяет качество ссылок по шкале
                                            от 0 до 100;
                                        </p>
                                        <p>
                                            <b>T</b> — предполагаемый ежемесячный органический
                                            трафик по данным ahrefs
                                        </p>
                                        <p>
                                            <b>K</b> — общее количество ключевых слов, по которым
                                            сайт в топ-100 результатов органического поиска по всем
                                            странам в базе данных ahrefs.
                                        </p>
                                        <p>
                                            <b>Рейтинг домена (DR)</b> — показывает силу ссылочного
                                            профиля сайта по сравнению с другими в базе данных
                                            ahrefs по 100-балльной шкале.
                                        </p>
                                        <p>
                                            <b>Price</b> — оценочная стоимость размещения ссылки,
                                        </p>
                                        <p>
                                            <b>Estimate</b> — на сколько донор подходит для
                                            размещения там ссылок.
                                        </p>
                                    </div>
                                    <div className="linkbuilder-system-item__bottom-text">
                                        В этом листе пользователь может отметить домены, которые его
                                        интересуют, и они появятся в Outreach list.
                                    </div>
                                </div>
                            </div>

                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-only">
                                        Research list
                                    </div>
                                    <div className="linkbuilder-system-item__img">
                                        <img
                                            src="/images/pic/linkbuilder/s1.png"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>

                                    <div className="linkbuilder-system-item__img-text">
                                        В этом листе пользователь может отметить домены, которые его
                                        интересуют, и они появятся в Outreach list.
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-system__grid linkbuilder-system__grid--center"
                        >
                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-only">
                                        Outreach list
                                    </div>
                                    <div className="linkbuilder-system-item__img">
                                        <img
                                            src="/images/pic/linkbuilder/s2.png"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-hidden">
                                        Outreach list
                                    </div>
                                    <CommonUsualText className="linkbuilder-system-item__subtitle">
                                        В этом списке отображены контакты владельца сайта, которые
                                        нашла нейросеть, общая оценка сайта-донора и relationship
                                        stage (стадия договоренности).
                                    </CommonUsualText>
                                </div>
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-system__grid linkbuilder-system__grid--center mobile-order"
                        >
                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-hidden">
                                        Projects
                                    </div>
                                    <CommonUsualText className="linkbuilder-system-item__subtitle">
                                        С одного аккаунта можно вести сразу несколько проектов и
                                        одновременно искать донорские сайты по разным тематикам.
                                    </CommonUsualText>
                                </div>
                            </div>

                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-only">
                                        Projects
                                    </div>
                                    <div className="linkbuilder-system-item__img">
                                        <img
                                            src="/images/pic/linkbuilder/s3.png"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-system__grid linkbuilder-system__grid--center "
                        >
                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-only">
                                        Email templates
                                    </div>
                                    <div className="linkbuilder-system-item__img">
                                        <img
                                            src="/images/pic/linkbuilder/s4.png"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="linkbuilder-system__col">
                                <div className="linkbuilder-system-item">
                                    <div className="linkbuilder-system-item__title mobile-hidden">
                                        Email templates
                                    </div>
                                    <CommonUsualText className="linkbuilder-system-item__subtitle">
                                        Пользователь также может воспользоваться функцией Email
                                        templates. Система сама разошлет email с предложением о
                                        покупке ссылки по найденным на сайтах контактам.
                                    </CommonUsualText>
                                </div>
                            </div>
                        </ScrollAnimation>

                        <div className="linkbuilder-system-bottom">
                            <div className="linkbuilder-system-bottom__top">
                                Сейчас сервис работает в режиме MVP (работающего прототипа). В
                                перспективе мы превратим Linkbuilder.Ai в полноценную CRM с единой
                                точкой входа.
                            </div>
                            <div className="linkbuilder-system-bottom__center">
                                <div className="linkbuilder-system-bottom__center-title">
                                    Но уже сейчас решение позволяет
                                </div>
                                <p>– получать более качественные доноры по меньшей цене;</p>
                                <p>– видеть всю необходимую аналитику в одном интерфейсе;</p>
                                <p>– на 70% снизить трудозатраты на рутинные операции.</p>
                            </div>
                            <div className="linkbuilder-system-bottom__link">
                                Вы можете проверить сервис сами в{' '}
                                <a
                                    href="https://linkbuilder.ai/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    режиме «демо»
                                </a>
                                , чтобы оценить его преимущества.
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default System;
